import { useState } from "react";
import "./RR_Video.css";

import Video1 from "../../videos/Video1 (1).mp4";
import Video2 from "../../videos/Video1 (2).mp4";
import Video3 from "../../videos/Video1 (3).mp4";
import Video4 from "../../videos/Video1 (4).mp4";
import Video5 from "../../videos/Video1 (5).mp4";
import Video6 from "../../videos/Video1 (6).mp4";

import VideoThumb1 from "../../images/RR Thumb (1).webp";
import VideoThumb2 from "../../images/RR Thumb (2).webp";
import VideoThumb3 from "../../images/RR Thumb (3).webp";
import VideoThumb4 from "../../images/RR Thumb (4).webp";
import VideoThumb5 from "../../images/RR Thumb (5).webp";
import VideoThumb6 from "../../images/RR Thumb (6).webp";

const videos = [
  { id: 1, src: Video1, thumbnail: VideoThumb1 },
  { id: 2, src: Video2, thumbnail: VideoThumb2 },
  { id: 3, src: Video3, thumbnail: VideoThumb3 },
  { id: 4, src: Video4, thumbnail: VideoThumb4 },
  { id: 5, src: Video5, thumbnail: VideoThumb5 },
  { id: 6, src: Video6, thumbnail: VideoThumb6 },
];

export default function RRGallery() {
  const [play, setPlay] = useState(null);

  return (
    <div className="frame-section">
      <h2 className="frame-title">Elegance in Every Frame</h2>

      <div className="frame-grid">
        {videos.map((item) => (
          <div className="frame-card" key={item.id}>
            {play === item.id ? (
              <video
                src={item.src}
                controls
                autoPlay
                className="video-element"
              />
            ) : (
              <div
                className="thumb-wrapper"
                onClick={() => setPlay(item.id)}
              >
                <img
                  src={item.thumbnail}
                  alt="thumbnail"
                  className="thumb-image"
                />
                <div className="play-icon">▶</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
